<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    chips
    :label="label"
    :error-messages="errors"
    item-text="name"
    item-value="id"
    :multiple="multiple"
    :rules="rules"
    :search-input.sync="searchInput"
    @change="searchInput = ''"
  >
    <template slot="selection" slot-scope="data">
      <v-chip
        :input-value="data.selected"
        class="chip--select-multi"
        close
        @input="remove(data.item)"
        @click:close="removeElementFromSelection(data.item.id)"
      >
        <v-avatar v-if="!avatarless">
          <img :src="data.item.avatar" />
        </v-avatar>
        {{ data.item.name }}
      </v-chip>
    </template>
    <template slot="item" slot-scope="data">
      <template>
        <v-list-item-avatar v-if="!avatarless">
          <img :src="data.item.avatar" />
        </v-list-item-avatar>
        <v-list-item-title v-html="data.item.name" />
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    items: {
      // An array of objects, which have the following keys:
      // 'id', 'name', 'avatar' (unless 'avatarless' prop is true)
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    avatarless: {
      type: Boolean
    },
    errors: {
      type: Array
    },
    rules: {
      type: Array
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selected: [],
      searchInput: ''
    }
  },
  watch: {
    selected() {
      this.$emit('input', this.selected)
    }
  },
  created() {
    if (this.multiple) {
      this.selected.push(...this.value)
    } else {
      this.selected = this.value
    }
  },
  methods: {
    setValue(newValue) {
      // Used from parent component via refs
      this.selected = newValue
    },
    removeElementFromSelection(id) {
      this.selected.remove(id)
    }
  }
}
</script>
